<template>
  <div>
    <stock-head-outer></stock-head-outer>
    <stock-list></stock-list>
  </div>
</template>

<script>
import StockHeadOuter from '../../components/modules/Catalog/StockHeadOuter'
import StockList from '../../components/modules/Catalog/StockList'
export default {
  name: 'StocksPage',
  metaInfo () {
    return {
      title: 'Каталог'
    }
  },
  pageClass: 'catalog-page',
  components: {
    StockHeadOuter,
    StockList
  },
  computed: {
  },
  methods: {
    prepare () {
    }
  },
  created () {
    this.prepare()
  }
}
</script>

<style scoped>

</style>
